<template>
    <transition name="loveshow-ui-show">
        <div class="toast dis-flex-center" v-show="show">
            <span>{{msg}}</span>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'toast',
  props: {},
  data() {
    return {

    };
  },
  computed: {
    msg() {
      return this.$store.state.toastMsg;
    },
    show() {
      return this.$store.state.toastShow;
    },
  },
};
</script>

<style scoped lang="scss">
.toast {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 28px;
  z-index: 100;
  width: 600px;

  span {
    display: inline-block;
    padding: 30px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 20px;
  }
}
</style>
